/* Óskalisti Vogue fyrir heimilið – vistaður í vafra (localStorage) */
(function () {
  var KEY = 'vogue_oskalisti';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('oskalisti:change', { detail: list }));
  }
  function toggle(h) {
    var list = read(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list);
    return i === -1;
  }
  function money(cents) {
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sync() {
    var list = read();
    document.querySelectorAll('.js-wish').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Fjarlægja af óskalista' : 'Bæta á óskalista');
      var l = b.querySelector('.js-wish-label');
      var txt = on ? 'Á óskalistanum' : 'Bæta á óskalista';
      if (l && l.textContent !== txt) l.textContent = txt;
    });
    document.querySelectorAll('.js-wish-count').forEach(function (c) {
      if (c.textContent !== String(list.length)) c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.js-wish');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(b.dataset.handle);
    if (added) { b.classList.remove('vf-pop'); void b.offsetWidth; b.classList.add('vf-pop'); }
  }, true);
  document.addEventListener('oskalisti:change', sync);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });

  function refreshCartBubble() {
    fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var el = document.getElementById('cart-icon-bubble');
      if (el && s['cart-icon-bubble']) {
        var d = document.createElement('div'); d.innerHTML = s['cart-icon-bubble'];
        var inner = d.querySelector('#cart-icon-bubble') || d.firstElementChild;
        if (inner) el.innerHTML = inner.innerHTML;
      }
    }).catch(function () {});
  }

  function card(p) {
    var url = root + 'products/' + p.handle;
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    var single = p.variants.length === 1;
    var priceHtml = (p.price_varies ? 'Frá ' : '') + money(p.price);
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var btn;
    if (!p.available) btn = '<span class="vf-wl__btn is-disabled">Uppselt</span>';
    else if (single) btn = '<button type="button" class="vf-wl__btn js-wl-add" data-id="' + p.variants[0].id + '">Setja í körfu</button>';
    else btn = '<a class="vf-wl__btn" href="' + url + '">Velja eiginleika</a>';
    return '<div class="vf-wl__item" data-handle="' + esc(p.handle) + '">' +
      '<button type="button" class="vf-wl__remove js-wl-remove" aria-label="Fjarlægja">&times; Fjarlægja</button>' +
      '<a class="vf-wl__img" href="' + url + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      (sale ? '<span class="vf-wl__badge">Tilboð</span>' : '') + '</a>' +
      '<div class="vf-wl__info">' +
      (p.vendor ? '<p class="vf-wl__vendor">' + esc(p.vendor) + '</p>' : '') +
      '<a class="vf-wl__title" href="' + url + '">' + esc(p.title) + '</a>' +
      '<p class="vf-wl__price">' + (sale ? '<s>' + money(p.compare_at_price) + '</s> <span class="is-sale">' + priceHtml + '</span>' : priceHtml) + '</p>' +
      btn + '</div></div>';
  }

  function renderPage() {
    var el = document.getElementById('oskalisti-root');
    if (!el) return;
    var shared = new URLSearchParams(location.search).get('vorur');
    var handles = shared ? shared.split(',').filter(Boolean) : read();
    var head = document.getElementById('oskalisti-head');
    if (head) {
      head.innerHTML = shared
        ? '<p class="vf-wl__lead">Þetta er óskalisti sem var deilt með þér.</p><button type="button" class="vf-wl__ghost js-wl-saveshared">Vista á minn óskalista</button>'
        : (handles.length ? '<p class="vf-wl__lead">' + handles.length + (handles.length === 1 ? ' vara' : ' vörur') + ' á listanum</p><button type="button" class="vf-wl__ghost js-wl-share">Deila óskalistanum</button>' : '');
    }
    if (!handles.length) {
      el.innerHTML = '<div class="vf-wl__empty"><p><strong>Óskalistinn þinn er tómur.</strong></p><p>Smelltu á hjartað á vöru til að vista hana hér.</p><a class="vf-wl__btn" href="' + root + 'collections/all">Skoða vörur</a></div>';
      return;
    }
    el.innerHTML = '<div class="vf-wl__grid">' + handles.map(function () { return '<div class="vf-wl__item is-loading"></div>'; }).join('') + '</div>';
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var found = products.filter(Boolean);
      if (!shared && found.length !== handles.length) write(found.map(function (p) { return p.handle; }));
      el.innerHTML = '<div class="vf-wl__grid">' + found.map(card).join('') + '</div>';
      if (shared) el.querySelectorAll('.js-wl-remove').forEach(function (b) { b.remove(); });
    });
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('.js-wl-remove'))) {
      var item = t.closest('.vf-wl__item');
      write(read().filter(function (h) { return h !== item.dataset.handle; }));
      renderPage();
    } else if ((t = e.target.closest('.js-wl-add'))) {
      t.disabled = true; t.textContent = 'Augnablik…';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +t.dataset.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; t.textContent = 'Komið í körfu ✓'; refreshCartBubble(); })
        .catch(function () { t.disabled = false; t.textContent = 'Reyndu aftur'; });
    } else if ((t = e.target.closest('.js-wl-share'))) {
      var link = location.origin + location.pathname + '?vorur=' + read().join(',');
      if (navigator.share) navigator.share({ title: 'Óskalistinn minn – Vogue fyrir heimilið', url: link }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(link).then(function () { t.textContent = 'Hlekkur afritaður ✓'; });
    } else if ((t = e.target.closest('.js-wl-saveshared'))) {
      var mine = read();
      new URLSearchParams(location.search).get('vorur').split(',').forEach(function (h) { if (h && mine.indexOf(h) < 0) mine.push(h); });
      write(mine);
      location.href = location.pathname;
    }
  });

  function init() { sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', sync);
  var pending = false;
  new MutationObserver(function (m) {
    if (pending) return;
    for (var i = 0; i < m.length; i++) {
      var n = m[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].nodeType === 1 && (n[j].matches('.js-wish') || n[j].querySelector('.js-wish'))) {
          pending = true;
          requestAnimationFrame(function () { pending = false; sync(); });
          return;
        }
      }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
